import { render, staticRenderFns } from "./PlansEquipmentDataTable.vue?vue&type=template&id=37d1a7ad&scoped=true&"
import script from "./PlansEquipmentDataTable.vue?vue&type=script&lang=js&"
export * from "./PlansEquipmentDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d1a7ad",
  null
  
)

export default component.exports